const IconOpen = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.5 12C5.5 12.5523 5.94772 13 6.5 13C7.05228 13 7.5 12.5523 7.5 12V7.59086H12C12.5523 7.59086 13 7.14315 13 6.59086C13 6.03858 12.5523 5.59086 12 5.59086H7.5V1C7.5 0.447715 7.05228 0 6.5 0C5.94771 0 5.5 0.447715 5.5 1V5.59086H1C0.447715 5.59086 0 6.03858 0 6.59086C0 7.14315 0.447715 7.59086 1 7.59086H5.5V12Z"
                fill="#1D1D1B"
            />
        </svg>
    )
}

export default IconOpen
